// -----------------------------------------------------------------------------
// Scripts for header
// -----------------------------------------------------------------------------

$(function () {
  const slider = $('.slider');
  const banner = $('.banner');

  if(slider.length || banner.length) {
    $('body').addClass('no-space');
  }
});